var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.003 2.12 9 6.617l8.996-4.497A2.25 2.25 0 0 0 15.75 0H2.25A2.25 2.25 0 0 0 .003 2.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 4.633-9 4.5-9-4.5v6.617a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 18 11.25z"
  }))));
};
export default SvgIconEmail;